<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import Button from 'primevue/button';
import { useUtilities } from '@apparatix/composables';
import type { DashboardEmail } from '@apparatix/schemas/DashboardEmails';
import { Stack } from '@apparatix/library/core';
import EmailMessageCard from './EmailMessageCard.vue';


type Props = {
  emails: DashboardEmail[],
};

const props = defineProps<Props>();

const { arrayHasValues, asKeyedItems } = useUtilities();

const isShowingAll = ref(false);
const messageVisibilityMap = ref<Map<number, boolean>>(new Map());

const keyedEmails = computed(() => asKeyedItems(props.emails));

const toggleAllVisibility = () => {
  const newValue = !isShowingAll.value;
  messageVisibilityMap.value.forEach((_, key) => messageVisibilityMap.value.set(key, newValue));
  isShowingAll.value = newValue;
};

const toggleMessageDetail = (emailId: number, showDetail: boolean) => messageVisibilityMap.value.set(emailId, showDetail);

onMounted(() => props.emails?.forEach(email => messageVisibilityMap.value.set(email.id, false)));
</script>
<template>
  <Stack :gap="0">
    <EmailMessageCard
      v-for="email in keyedEmails"
      :key="email.key"
      :email="email"
      :expanded="messageVisibilityMap.get(email.id)"
      :show-border="keyedEmails.length >= 2"
      @toggle-detail="toggleMessageDetail"
    />
    <div v-if="arrayHasValues(props.emails, {min: 2})" class="pt-4 pl-6">
      <Button
        severity="secondary"
        size="small"
        :label="isShowingAll ? 'Hide all' : 'Show all'"
        @click="toggleAllVisibility"
      />
    </div>
  </Stack>
</template>
